import { render } from "./SchedaVisualizzazioneUtente.vue?vue&type=template&id=c54e0a2e"
import script from "./SchedaVisualizzazioneUtente.vue?vue&type=script&lang=js"
export * from "./SchedaVisualizzazioneUtente.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__